import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-phase-transformers',
  templateUrl: './single-phase-transformers.component.html',
  styleUrls: ['./single-phase-transformers.component.css']
})
export class SinglePhaseTransformersComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
